(() => {
  const roots = document.querySelectorAll('[data-cara-lp-sticky]');

  roots.forEach((root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const store = window.CaraLpSelection;
    if (!store) {
      console.warn('CaraLpSelection store is missing.');
      return;
    }

    const colorsEl = root.querySelector('[data-cara-sticky-colors]');
    const sizesEl = root.querySelector('[data-cara-sticky-sizes]');
    const qtyInput = root.querySelector('[data-cara-sticky-qty-input]');
    const qtyDec = root.querySelector('[data-cara-sticky-qty-dec]');
    const qtyInc = root.querySelector('[data-cara-sticky-qty-inc]');
    const addButton = root.querySelector('[data-cara-sticky-add]');
    const addLabel = root.querySelector('[data-cara-sticky-add-label]');
    const status = root.querySelector('[data-cara-sticky-status]');
    const buttonLabel = root.dataset.buttonLabel || 'Add to cart';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const observeSelector = root.dataset.observeTarget || '#cara-lp-buybox';

    let applyingSnapshot = false;
    let lastHandle = '';
    let busy = false;
    let currentSnapshot = store.getSnapshot();

    function cartRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    function setStatus(message, type = '') {
      if (!status) return;
      const text = message || '';
      status.textContent = text;
      status.classList.toggle('is-warning', type === 'warning');
      status.classList.toggle('is-error', type === 'error');
      if (text) status.removeAttribute('hidden');
      else status.setAttribute('hidden', '');
    }

    function clearStatus() {
      setStatus('');
    }

    function syncQtyButtons(snapshot) {
      const current = Number(qtyInput?.value) || 1;
      const max = snapshot?.max;
      const min = 1;

      if (qtyDec) {
        const atMin = current <= min;
        qtyDec.disabled = atMin;
        qtyDec.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      }

      if (qtyInc) {
        const atMax = typeof max === 'number' && current >= max;
        qtyInc.disabled = false;
        qtyInc.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      }
    }

    function renderColors(snapshot) {
      if (!colorsEl) return;
      colorsEl.innerHTML = '';

      (snapshot.colors || []).forEach((color) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cara-lp-sticky__color';
        button.dataset.handle = color.handle;
        button.title = color.colorName || color.handle;
        button.setAttribute('aria-label', color.colorName || color.handle);
        button.setAttribute('role', 'listitem');
        if (color.handle === snapshot.handle) button.classList.add('is-active');

        const swatch = document.createElement('span');
        swatch.className = 'cara-lp-sticky__swatch';
        swatch.style.setProperty('--swatch', color.swatch || '#ccc');
        button.appendChild(swatch);

        button.addEventListener('click', async () => {
          clearStatus();
          try {
            await store.setColor(color.handle);
          } catch (error) {
            console.warn('Sticky color load failed.', error);
            setStatus('Unable to load this color. Please try again.', 'error');
          }
        });

        colorsEl.appendChild(button);
      });
    }

    function renderSizes(snapshot) {
      if (!sizesEl) return;
      sizesEl.innerHTML = '';
      const product = snapshot.product;
      if (!product) return;

      product.variants.forEach((variant) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cara-lp-sticky__size';
        const title = variant.title || '';
        const shortTitle = title.includes(' / ') ? title.split(' / ').pop() : title;
        button.textContent = shortTitle;
        button.title = title;
        button.disabled = !variant.available;
        button.setAttribute('role', 'listitem');
        if (String(variant.id) === String(snapshot.variantId)) {
          button.classList.add('is-active');
        }
        button.addEventListener('click', () => {
          clearStatus();
          store.setSize(variant.id);
        });
        sizesEl.appendChild(button);
      });
    }

    function applySnapshot(snapshot) {
      if (!snapshot?.ready) return;
      applyingSnapshot = true;
      currentSnapshot = snapshot;

      try {
        if (lastHandle !== snapshot.handle) {
          renderColors(snapshot);
          lastHandle = snapshot.handle;
        } else {
          colorsEl?.querySelectorAll('.cara-lp-sticky__color').forEach((button) => {
            button.classList.toggle('is-active', button.dataset.handle === snapshot.handle);
          });
        }

        renderSizes(snapshot);

        if (qtyInput) qtyInput.value = String(snapshot.qty);
        syncQtyButtons(snapshot);

        const available = Boolean(snapshot.available);
        if (addButton) addButton.disabled = !available || busy;
        if (addLabel) addLabel.textContent = available ? buttonLabel : soldOutLabel;
      } finally {
        applyingSnapshot = false;
      }
    }

    function setVisible(visible) {
      if (visible) root.removeAttribute('hidden');
      else root.setAttribute('hidden', '');
    }

    function updateVisibilityFromBuybox(target) {
      if (!target) {
        setVisible(true);
        return;
      }
      const rect = target.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      const visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
      const ratio = visibleHeight > 0 ? visibleHeight / Math.max(rect.height, 1) : 0;
      // Show sticky once the buybox is mostly out of view.
      setVisible(ratio < 0.15);
    }

    function observeBuybox() {
      const target = document.querySelector(observeSelector);
      if (!target) {
        setVisible(true);
        return;
      }

      updateVisibilityFromBuybox(target);

      if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(
          () => updateVisibilityFromBuybox(target),
          {
            root: null,
            threshold: [0, 0.15, 0.5, 1]
          }
        );
        observer.observe(target);
      }

      window.addEventListener('scroll', () => updateVisibilityFromBuybox(target), { passive: true });
      window.addEventListener('resize', () => updateVisibilityFromBuybox(target), { passive: true });
    }

    qtyDec?.addEventListener('click', () => {
      if (applyingSnapshot) return;
      const next = Math.max(1, (Number(qtyInput?.value) || 1) - 1);
      store.setQty(next);
    });

    qtyInc?.addEventListener('click', () => {
      if (applyingSnapshot) return;
      const current = Number(qtyInput?.value) || 1;
      const max = currentSnapshot?.max;
      if (typeof max === 'number' && current >= max) {
        setStatus(
          max === 1 ? 'Only 1 left in stock.' : 'Maximum available quantity reached.',
          'warning'
        );
        syncQtyButtons(currentSnapshot);
        return;
      }
      store.setQty(current + 1);
    });

    qtyInput?.addEventListener('change', () => {
      if (applyingSnapshot) return;
      store.setQty(Number(qtyInput.value) || 1);
    });

    addButton?.addEventListener('click', async () => {
      if (busy) return;
      const snapshot = store.getSnapshot();
      if (!snapshot.variantId || !snapshot.available) return;

      busy = true;
      addButton.disabled = true;
      clearStatus();

      try {
        const formData = new FormData();
        formData.set('id', String(snapshot.variantId));
        formData.set('quantity', String(snapshot.qty || 1));

        const response = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok) {
          const message = payload?.description || payload?.message || 'Unable to add to cart.';
          setStatus(message, 'error');
          return;
        }

        window.location.href = `${cartRoot()}cart`;
      } catch (error) {
        console.warn('Sticky add to cart failed.', error);
        setStatus('Unable to add to cart.', 'error');
      } finally {
        busy = false;
        const latest = store.getSnapshot();
        if (addButton) addButton.disabled = !latest.available;
      }
    });

    store.subscribe(applySnapshot);
    observeBuybox();

    // Escape section stacking contexts so we sit above Shopify Inbox / chat widgets.
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }
  });
})();
